import emailjs from '@emailjs/browser';
import { useState } from 'react';
import { FaPhoneAlt, FaUser } from 'react-icons/fa';
import RenderToast from '../RenderToast';
import styles from './GetQuote.module.css';

const initialValues = {
  name: '',
  phone: '',
};

const emailJsConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_QUOTE_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_QUOTE_TEMPLATE_ID,
  publicKey: process.env.REACT_APP_EMAILJS_QUOTE_PUBLIC_KEY,
};

export default function GetQuote({ className = '' }) {
  const [formValues, setFormValues] = useState(initialValues);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormValues((currentValues) => ({
      ...currentValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedName = formValues.name.trim();
    const trimmedPhone = formValues.phone.trim();

    if (!trimmedName) {
      RenderToast({
        type: 'error',
        message: 'Please enter your name. It is required.',
      });
      return;
    }

    if (!trimmedPhone) {
      RenderToast({
        type: 'error',
        message: 'Please enter your phone number. It is required.',
      });
      return;
    }

    if (!emailJsConfig.serviceId || !emailJsConfig.templateId || !emailJsConfig.publicKey) {
      RenderToast({
        type: 'error',
        message: 'Quote email service is not configured yet. Add the EmailJS quote keys to your .env.local file.',
      });
      return;
    }

    try {
      setIsSubmitting(true);

      await emailjs.send(
        emailJsConfig.serviceId,
        emailJsConfig.templateId,
        {
          from_name: trimmedName,
          phone: trimmedPhone,
        },
        {
          publicKey: emailJsConfig.publicKey,
        }
      );

      RenderToast({
        type: 'success',
        message: 'Your quote request has been submitted successfully.',
      });

      setFormValues(initialValues);
    } catch (error) {
      RenderToast({
        type: 'error',
        message: 'We could not send your quote request right now. Please try again in a moment.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className={`${styles.form} ${className}`.trim()} onSubmit={handleSubmit} noValidate>
      <label className={styles.field}>
        <span className={styles.icon} aria-hidden="true">
          <FaUser />
        </span>
        <input
          type="text"
          name="name"
          value={formValues.name}
          onChange={handleChange}
          placeholder="Name ..."
          autoComplete="name"
        />
      </label>

      <label className={styles.field}>
        <span className={styles.icon} aria-hidden="true">
          <FaPhoneAlt />
        </span>
        <input
          type="tel"
          name="phone"
          value={formValues.phone}
          onChange={handleChange}
          placeholder="Phone ..."
          autoComplete="tel"
        />
      </label>

      <button type="submit" className={styles.submitButton}>
        {isSubmitting ? 'Sending...' : "Let's Connect"}
      </button>
    </form>
  );
}
